import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../AuthContext';
import Spinner from '../components/Spinner';

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  React.useEffect(() => {
    if (loading) {
      return;
    }

    navigate(isAuthenticated ? '/' : '/login', { replace: true });
  }, [isAuthenticated, loading, navigate]);

  return <Spinner />;
};

export default OAuthCallback;
